import { GoogleTTSLanguage } from "callable-data-objects/dist/enums/GoogleTTSLanguage";
import { useField } from "formik";
import React from "react";
import { Dropdown, Form, Label } from "semantic-ui-react";

const TTSSelect = ({ label, ...props }: any) => {
  const [field, meta, helpers] = useField(props);

  const languages = [];

  for (const [propertyKey, propertyValue] of Object.entries(
    GoogleTTSLanguage
  )) {
    if (Number.isNaN(Number(propertyKey))) {
      languages.push({
        id: propertyValue,
        key: propertyValue,
        value: propertyValue,
        text: propertyKey,
      });
    }
  }

  console.log(field.value, languages);
  return (
    <Form.Field>
      <label>{label}</label>
      <Dropdown
        label={label}
        clearable
        fluid
        search
        selection
        options={languages}
        name={field.name}
        defaultValue={field.value}
        placeholder='Select TTS Language'
        onChange={(event, { value }) => {
          helpers.setValue(value);
        }}
      />
      {meta.error && (
        <Label basic color='red' pointing>
          {meta.error}
        </Label>
      )}
    </Form.Field>
  );
};

export default TTSSelect;
